import React from 'react';
import './QuestionPreview.css';
import QuestionText from './QuestionText';
import OptionText from './OptionText';

const QuestionPreview = ({ data, metadata }) => {
    console.log('Data', data);
    const { text, type, points, imageUrl, Options = [], correctAnswerText } = data;

    // Resolve human-readable labels from IDs if available
    const gradeName = metadata?.grades?.find(g => String(g.id) === String(metadata.selectedGrade))?.name;
    const subjectName = metadata?.subjects?.find(s => String(s.id) === String(metadata.selectedSubject))?.name;
    const topicName = metadata?.topics?.find(t => String(t.id) === String(data.topicId))?.name;

    const visibleOptions = type === 'MCQ' ? Options.slice(0, 4) : Options.slice(0, 2);

    return (
        <div className="qp-card">
            <div className="qp-header">
                <div className="qp-tags">
                    <span className="qp-badge qp-badge-type">{type || 'MCQ'}</span>
                    {points !== undefined && points !== '' && (
                        <span className="qp-badge qp-badge-points">{points} PTS</span>
                    )}
                    {gradeName && <span className="qp-badge qp-badge-meta">{gradeName}</span>}
                    {subjectName && <span className="qp-badge qp-badge-meta">{subjectName}</span>}
                    {topicName && <span className="qp-badge qp-badge-meta">{topicName}</span>}
                </div>
            </div>

            {imageUrl && (
                <div className="qp-image-wrapper">
                    <img 
                        src={imageUrl} 
                        alt="Question media" 
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                </div>
            )}

            <div className="qp-body">
                <p className="qp-text">
                    <QuestionText text={text?.trim() ? text : <span className="qp-placeholder">Question prompt will appear here...</span>} />
                </p>
            </div>

            <div className="qp-answers">
                {type === 'SHORT' ? (
                    <div className="qp-short-answer">
                        <span className="qp-short-label">Expected Answer:</span>
                        <span className="qp-short-val">
                            {correctAnswerText?.trim() || <span className="qp-placeholder">Not defined yet</span>}
                        </span>
                    </div>
                ) : (
                    <div className="qp-options-grid">
                        {visibleOptions.map((opt, i) => {
                            const defaultTfText = i === 0 ? 'True' : 'False';
                            const displayText = opt.text?.trim() || (type === 'TF' ? defaultTfText : `Option ${i + 1}`);

                            return (
                                <div 
                                    key={i} 
                                    className={`qp-option ${opt.isCorrect ? 'qp-correct' : ''}`}
                                >
                                    <span className="qp-option-text"><OptionText text={displayText} /></span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuestionPreview;